export interface IceServerResponse {
  session_id: string;
  iceServers: RTCIceServer[];
}

export interface SdpOfferRequest {
  session_id: string;
  restaurant_id: string;
  table_id: string;
  user_id?: string;
}

export interface SdpAnswerRequest {
  session_id: string;
  sdp: string;
  type: 'answer';
}

export interface SdpOfferResponse {
  session_id: string;
  sdp: string;
  type: 'offer';
}

export enum WebRTCErrorType {
  CONNECTION_FAILED = 'connection_failed',
  SIGNALING_ERROR = 'signaling_error',
  ICE_FAILED = 'ice_failed',
  DATACHANNEL_ERROR = 'datachannel_error',
}

export interface WebRTCMessage {
  type: 'TXT' | 'START_RECORDING' | 'STOP_RECORDING';
  text?: string;
}

export interface WebRTCServerReply {
  reply: {
    output_text?: string;
    output_audio?: string;
    audio_format?: string;
  };
  actions?: BotAction[];
}

export interface BotAction {
  name: string;
  parameters: Record<string, any>;
}

